// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__178q1","label":"styles_label__FaGfb"};